import { Checkbox } from './Checkbox';

export type { TypeCheckboxProps } from './types';
export default Checkbox;
